import type {
  MasterFieldDef,
  TemplateHint,
  TraceKey,
} from '@ulysses-inc/harami_api_client'
import { EditTemplateState } from 'src/state/ducks/templates/editTemplate/reducer'
import { TemplatePagesState } from 'src/state/ducks/templates/templatePages/reducer'

// 汎用的なResult型
// NOTE: 他の箇所でもResult型を使う場合は共通化を検討
export type Result<T, E> =
  | { readonly isOk: true; readonly value: T }
  | { readonly isOk: false; readonly error: E }
export const ok = <T = void>(value?: T): Result<T, never> =>
  ({
    isOk: true,
    value: value as T,
  }) as const

export const err = <E>(error: E): Result<never, E> =>
  ({
    isOk: false,
    error,
  }) as const

// ひな形編集バリデーション用のエラー型
export type ValidationError = {
  message: string
  type: 'template' | 'page' | 'hint' | 'reportName' | 'master'
}

// ひな形編集バリデーション用のResult型
export type ValidationResult<T = void> = Result<T, ValidationError>

// ひな形編集バリデーション用のパラメータ型
export type ValidateParams = {
  templateData: EditTemplateState
  templateHints: TemplateHint[]
  templatePagesData: TemplatePagesState
  masterFieldDefs: MasterFieldDef[]
  traceKeys: TraceKey[]
}
